"use client";

import { User } from "@/models/user";
import { createContext, useContext, useRef } from "react";

interface StoreActionContextProps {
  aiActionRef: React.RefObject<{
    open: () => void;
  } | null>;
}

const storeActionContext = createContext<StoreActionContextProps | undefined>(
  undefined
);

export const StoreActionProvider = ({
  children,
  user,
  lang,
}: {
  children: React.ReactNode;
  user: User | undefined;
  lang: string;
}) => {
  const aiActionRef = useRef<{ open: () => void }>(null);

  const value = {
    aiActionRef: aiActionRef,
  };

  return (
    <storeActionContext.Provider value={value}>
      {children}
    </storeActionContext.Provider>
  );
};

export const useStoreAction = () => {
  const context = useContext(storeActionContext);
  if (context === undefined) {
    throw new Error("useStoreAction must be used within a StoreActionProvider");
  }
  return context;
};
